const capitalize = (input: string) => {
  if (!input) return undefined;

  return input
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export default capitalize;
